<template>
  <Layout>
    <template v-slot:navigation>
      <topNav />
    </template>
    <template v-slot:content>
      <div class="custom-container-fluid" style="margin-top: 10rem">
        <div class="row">
          <div class="col-md-12 text-center" v-if="error">
            <img
              src="../../public/assets/images/error.png"
              style="width: 200px"
              class="img-fluid"
              alt=""
            />
            <h5>
              Error whiles getting startups
            </h5>
            <router-link to="/">Go to home</router-link>
          </div>

          <div class="col-md-12" v-else>
            <!--            <div class="table-responsive">-->
            <!--              <table class="table table-borderless table-hover ">-->
            <!--                <thead>-->
            <!--                <tr class="text-green">-->
            <!--                  <th scope="col">Startup</th>-->
            <!--                  <th scope="col">Sector</th>-->
            <!--                  <th scope="col">Year founded</th>-->
            <!--                  <th scope="col">Investment Raised</th>-->
            <!--                  <th scope="col">Region</th>-->
            <!--                  <th scope="col">stage</th>-->
            <!--                  <th scope="col">Action</th>-->
            <!--                </tr>-->
            <!--                </thead>-->
            <!--              </table>-->
            <!--            </div>-->

            <div class="card table-responsive table-card">
              <table class="table table-borderless table-hover">
                <thead>
                  <tr class="text-green">
                    <th scope="col">Startup</th>
                    <th scope="col">Sector</th>
                    <th scope="col">Year founded</th>
                    <th scope="col">Investment Raised</th>
                    <th scope="col">Region</th>
                    <th scope="col">stage</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody v-if="!isLoading">
                  <tr v-for="(s, i) in startups" :key="i">
                    <td><img :src="s['logo']?s['logo']:'../assets/images/startup_placeholder.jpeg'" alt="" class="img-fluid mr-2" style="width: 70px; height: 70px; object-fit: cover;" />{{ s["team_name"] }}</td>
                    <td>{{ s["sector"] }}</td>
                    <td>{{ s["year_founded"] }}</td>
                    <td>N/A</td>
                    <td>N/A</td>
                    <td>Early</td>
                    <td>
                      <router-link
                        :to="'/view-profile/' + s['team_id']+'/program/'+s['program_id']"
                        class="btn btn-sm border-0"
                        style="background: rgba(242,101,38,0.46); box-shadow: none; color: #F26526"
                      >
                        View Profile
                      </router-link>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr v-for="(a,i) in 8" :key="i">
                    <th><div class="lines shine" /></th>
                    <th><div class="lines shine" /></th>
                    <th><div class="lines shine" /></th>
                    <th><div class="lines shine" /></th>
                    <th><div class="lines shine" /></th>
                    <th><div class="lines shine" /></th>
                    <th><div class="lines shine" /></th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Layout>
</template>

<script>
import layout from "@/components/app-layout";
import navigation from "@/components/topNav";
import axios from "axios";

export default {
  components: {
    Layout: layout,
    topNav: navigation
  },
  data: () => {
    return {
      startups: [],
      isLoading: false,
      error: false
    };
  },
  methods: {
    getStartups() {
      this.isLoading = true;
      axios
        .get(`${process.env.VUE_APP_ENDPOINT_BASE_URL}/startups`)
        .then(res => {
          this.startups = res.data.data;
        })
        .catch(() => {
          this.error = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  created() {
    document.body.style.background = "#F3F7FF";
    this.getStartups();
  },
  mounted() {}
};
</script>

<style scoped>
.table-card {
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
}
/*.table th .table td{*/
/*  border-top: none !important;*/
/*}*/

thead {
  background: #f3f7ff;
}

.table th,
.table td {
  text-align: center;
  border-top: 0;
  vertical-align: baseline;
}
@media screen and (max-width: 600px) {
}
</style>
